// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._COZaTV7hiunFN {
  margin: 24px;
  text-align: center;
}
.zZ7nmUAeRGiMhu {
  max-height: 264px;
}
.zZ7nmUAeRGiMhu.Yz8iCthJ55_9x0 {
  overflow-y: scroll;
}
.RcmsMtELGaZXv0 {
  display: flex;
  flex-direction: column;
  min-height: 350px;
  max-height: 560px;
  background: var(--ds-surface, #ffffff);
}
.RcmsMtELGaZXv0.JsyPErtoufglrM {
  height: auto;
}
.RcmsMtELGaZXv0.vYo5uEA8FS62fk {
  justify-content: center;
}
@media only screen and (max-width: 750px) {
  .RcmsMtELGaZXv0 {
    flex-basis: auto;
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 170px;
    margin-bottom: 12px;
  }
}
.ic4HZJmtTZpEhd {
  height: 100%;
  margin-top: 24px;
  overflow-y: auto;
}
.sHsOERw12vW4dV {
  margin-bottom: 24px;
}
.sHsOERw12vW4dV:last-child {
  margin-bottom: 0;
}
.vlioU4X_VWayUj {
  margin-top: 16px;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  letter-spacing: -0.003em;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: 0;
}
.bNME0oaGvX0YDs {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.g_gHseDl1OI17h {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.r0OLU7WfSRipPi {
  margin: 0 12px 24px 12px;
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `_COZaTV7hiunFN`,
	"workspaceList": `zZ7nmUAeRGiMhu`,
	"scroll": `Yz8iCthJ55_9x0`,
	"listBoxContainer": `RcmsMtELGaZXv0`,
	"responsive": `JsyPErtoufglrM`,
	"empty": `vYo5uEA8FS62fk`,
	"workspacesContainer": `ic4HZJmtTZpEhd`,
	"workspacesGroup": `sHsOERw12vW4dV`,
	"groupHeader": `vlioU4X_VWayUj`,
	"spinnerContainer": `bNME0oaGvX0YDs`,
	"noWorkspaceContainer": `g_gHseDl1OI17h`,
	"noWorkspaceText": `r0OLU7WfSRipPi`
};
export default ___CSS_LOADER_EXPORT___;
